import { render, staticRenderFns } from "./Leadership.vue?vue&type=template&id=4fd5db28&scoped=true&"
import script from "./Leadership.vue?vue&type=script&lang=js&"
export * from "./Leadership.vue?vue&type=script&lang=js&"
import style0 from "./Leadership.vue?vue&type=style&index=0&id=4fd5db28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd5db28",
  null
  
)

export default component.exports